
import {
  onBeforeUnmount,
  onMounted,
  onActivated,
  onDeactivated,
  inject,
  ref,
  reactive,
  Ref,
  nextTick,
  getCurrentInstance,
  computed,
  watch,
} from "vue";
import SkuCard from "../../components/skuCard/index.vue";
import { useRouter, useRoute } from "vue-router";
import { querySkuInfo, querySkuList } from "@/api/aio";
import lottie from "lottie-web";
import {
  changeActionBar,
  getClientCommonMessage,
  getStatusBarInfo,
  nativeGoBack,
  nativeShowAioShare,
  doJump,
} from "../../utils/nativeFn";
import { registerFnHandler } from "../../utils/registerFnHandler";
import WrongPage from "../../components/WrongPage.vue";
import LoadingPage from "../../components/LoadingPage.vue";
import { getUrlParam } from "../../utils/parseUrl";
import { dealLottiePath } from "../../utils/prefixLottie";
import ActionBar from "../../components/ActionBar/index.vue";
import { compareVersion } from "@/utils/compareVersion";
import gesture_tap_json from "/public/lottie/gesture/gesture_tap.json";
import { isIOS } from "@/assets/js/utils";
import store from "@/store/index";
interface ChangeActionBarParams {
  color?: string; // 字体颜色
  bgColor: string; // 需要改变的色值
  mode: string; // 背景颜色是深色还是浅色
}
export default {
  components: {
    SkuCard,
    WrongPage,
    LoadingPage,
    ActionBar,
  },
  setup() {
    const gradeOverflow = ref(0)
    const $xesLog = inject("$xesLog") as any; // 埋点
    const router = useRouter();
    store.commit("taskPaper/SET_DATA", ["skuDetailQuery", useRoute().query || {}]);
    const gradeWrapRef = ref(null);
    const gradeRef = ref(null);
    const loading = ref(false);
    const finished = ref(false); // 是否加载完成
    const skuInfo = ref({}); // sku信息
    const pageNumber = ref(0);
    const isNoData = ref(false); // 是否有数据
    const cardList = ref([]); // 卡牌信息
    const pageInfo = ref({}); // 分页信息
    const currenClickItem = ref(null); // 当前点击的卡片 card详情页返回时用到
    const currentKey = ref(0); // 当前点击的Index
    const pageLimit = 27; // 每页条数
    const clickCardStatus = ref(false);
    const showWrongPage = ref(false); // 是否展示接口失败后页面
    const isLoading = ref(false); // 接口loading
    const u = navigator.userAgent;
    let statusBarHeight = ref(35); // 状态栏高度
    let actionBarHeight = ref(79); // 默认actionBar高度
    const actionBarInfo = reactive({}); // actionBar需要的参数
    const showActionBar = ref(false); // 是否开启 actionBar 默认false, 版本大于 1.7.0开启
    const displayTabWrapFixed = ref('none');
    const refTabWrap = ref(null)
    const refTabWrapFixed = ref(null)
    const refCardDetailWrap = ref(null)
    const refSkuBox = ref(null)
    let user_id = "";
    const oneStarGuideTitle = ref("快来点亮知识卡牌吧～");
    const twoStarGuideTitle = ref("3星卡牌上线啦，快来升级");
    const isShowTwoStarGuide = ref(false);
    const isNeedSetTwoStarGuide = ref(false)
    let star_notice_show_text = "";
    const { unionid = "gc_06a1c08116f87", source_location = "" } = useRoute().query || {};
    // console.log(unionid, source_location, "url参数");

    let isFromCardDetail = false;

    const isShowFirstInGuide = computed(() => {
      // console.log(
      //   (cardList.value || []).every((card) => card.user_card_star <= 0) &&
      //     clickCardStatus.value,
      //   "是否展示lottie"
      // );
      return (
        (cardList.value || []).every((card) => card.user_card_star <= 0) &&
        clickCardStatus.value
      );
    });
    /**
     * 加载卡片list
     */
    const onLoad = () => {
      pageNumber.value++;
      skuListInit(pageNumber.value);
    };
    /**
     * sku基本信息
     */
    const skuInfoInit = () => {
      const skuInfoParams = {
        unionid: unionid as string,
      };
      return new Promise((resolve, reject) => {
        querySkuInfo(skuInfoParams)
          .then((res) => {
            if (res.data.code === 0) {
              res.data.data.show_grade = res.data.data?.show_grade?.split("|") || []
              skuInfo.value = res.data.data;
              nextTick(() => {
                gradeOverflow.value = gradeWrapRef.value.offsetHeight - gradeRef.value.offsetHeight
              })
              if (!isIOS()) {
                console.log("安卓title设置");
                document.title = (skuInfo.value as any).column_title;
              }
            }
            resolve(res);
          })
          .catch((e) => {
            showWrongPage.value = true;
            reject(e);
          });
      });
    };
    /**
     * sku列表信息
     */
    const skuListInit = (page) => {
      const skuListParams = {
        column_unionid: unionid as string,
        page: page,
        limit: pageLimit,
      };
      return new Promise((resolve, reject) => {
        querySkuList(skuListParams)
          .then((res) => {
            try {
              if (res.data.code === 0) {
                const skuListInfo = res.data.data || {};
                const fetchCardList = skuListInfo.card_list || [];
                pageInfo.value = skuListInfo.page_info;
                cardList.value = [...cardList.value, ...fetchCardList];
                // list加载状态结束
                loading.value = false;
                // 数据全部加载完成
                const totalCount = (pageInfo.value as any)?.count;
                if (cardList.value.length >= totalCount) {
                  finished.value = true;
                }
              } else {
                showWrongPage.value = true;
              }
            } catch (error) {
              console.log(error);
              showWrongPage.value = true;
            }
            resolve(res);
          })
          .catch((e) => {
            showWrongPage.value = true;
            reject(e);
          });
      });
    };
    /**
     * 跳转到卡片详情
     */
    const handleToDetail = (item, key) => {
      const scrollTop =
        refSkuBox.value.scrollTop ||
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      sessionStorage.setItem("scrollTopPosition", scrollTop.toString());
      currenClickItem.value = item;
      currentKey.value = key;
      isFromCardDetail = true;
      clickCardStatus.value = false;
      //  点击卡牌埋点
      skuCardClick(item);
      // 跳转到卡片详情
      router.push({
        // path: "/card-detail",
        name: "CardDetail",
        query: {
          cardId: item.unionid,
          cardType: item.card_type,
          skuId: unionid,
          skuName: encodeURI((skuInfo.value as any)?.column_title || ""),
          source_location: "sku_detail",
        },
      });
    };
    /**
     *  某个卡片数据&sku信息重新更新赋值
     */
    const reSetSkuInfo = (receivePage?: number, selectUpCard?: any) => {
      selectUpCard = selectUpCard || [`${currenClickItem.value?.unionid}`];
      let needGetPage = 0; // 当前点击的卡片是在第几页
      if (receivePage) {
        needGetPage = receivePage;
      } else {
        if (currentKey.value % pageLimit == 0) {
          needGetPage = currentKey.value / pageLimit + 1;
        } else {
          needGetPage = Math.floor(currentKey.value / pageLimit) + 1;
        }
      }
      // 更新某个卡片信息
      querySkuList({
        column_unionid: unionid as string,
        page: needGetPage,
        limit: pageLimit,
      })
        .then((res) => {
          const selectList = res.data?.data?.card_list || [];
          const tmpMap = {};
          selectList.forEach((item) => {
            if (selectUpCard && selectUpCard.includes(item.unionid)) {
              tmpMap[item.unionid] = item;
            }
          });
          // 点击的卡片更新数据
          (cardList.value || []).forEach((currCard, index) => {
            if (tmpMap[currCard.unionid]) {
              cardList.value[index] = tmpMap[currCard.unionid];
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    };
    /**
     *
     */
    const backToTaskReSet = () => {
      // 更新sku基本信息
      skuInfoInit();
      isFromCardDetail = false;
      // 更新某个卡牌信息
      const cardUnionids = JSON.parse(sessionStorage.getItem("cardUnionids") || "[]");
      if (cardUnionids.length > 0) {
        let tmpPageSet = [];
        cardList.value.forEach((selectCard, key) => {
          if (cardUnionids.includes(selectCard.unionid)) {
            const pageNumber = Math.floor(key / pageLimit) + 1;
            !tmpPageSet.includes(pageNumber) && tmpPageSet.push(pageNumber);
          }
        });
        tmpPageSet.forEach((pageNumber) => {
          reSetSkuInfo(pageNumber, cardUnionids);
        });
      } else {
        reSetSkuInfo();
      }
      // 重置数据
      window.sessionStorage.setItem("cardUnionids", "[]");
    };
    /**
     * 返回当前页面滚动到点击位置
     */
    const scrollToClickPos = () => {
      nextTick(() => {
        const scrollTop = sessionStorage.getItem("scrollTopPosition");
        refSkuBox.value.scrollTop = Math.ceil(Number(scrollTop || 0))
        sessionStorage.removeItem("scrollTopPosition");
      });
    };
    /**
     * 接口请求失败后重新刷新接口请求
     */
    const clickRefresh = () => {
      // const freshPage = 1;
      showWrongPage.value = false;
      // 重新加载数据
      cardList.value = [];
      pageInfo.value = {};
      pageNumber.value = 0;
      firstDataInit();
    };
    /***
     * 隐藏新手引导
     * type: 1: 没有点亮卡牌 2: 2星卡牌
     */
    const hideFirstInGuide = (type) => {
      if (type === 1) {
        clickCardStatus.value = false;
        cardList.value.length && handleToDetail(cardList.value?.[0], 0);
      } else {
        isShowTwoStarGuide.value = false;
        console.log(
          `${user_id}${skuInfo.value["unionid"]}`,
          "----本地存储二星任务标识----"
        );
        cardList.value.length && handleToDetail(cardList.value?.[0], 0);
      }
    };
    /**
     * 二星卡牌引导是否展示
     *  1. 服务端接口字段 is_show_card_label 是否为1
     *  2. localStorage 是否有 user_id + unionid
     *  3. localStorage 中 user_id + unionid 对应的文案与 服务端返回文案是否一致
     */
    const isShow2StarGuide = () => {
      let flag = localStorage.getItem(`${user_id}${skuInfo.value["unionid"]}`);
      console.log(
        skuInfo.value["is_show_card_label"] === 1 &&
        !isShowFirstInGuide.value &&
        flag !== twoStarGuideTitle.value,
        "二星引导判断（1. 一星卡牌状态 2.local存储value）"
      );
      if (
        skuInfo.value["is_show_card_label"] === 1 &&
        !isShowFirstInGuide.value &&
        flag !== twoStarGuideTitle.value
      ) {
        isShowTwoStarGuide.value = true;
        isNeedSetTwoStarGuide.value = true;
        nextTick(() => {
          renderLottie(2);
        });
        let lottie2Timer = setTimeout(() => {
          isShowTwoStarGuide.value = false;
          localStorage.setItem(
            `${user_id}${skuInfo.value["unionid"]}`,
            twoStarGuideTitle.value
          );
          clearTimeout(lottie2Timer);
        }, 2000);
      } else {
        isShowTwoStarGuide.value = false;
      }
    };
    /**
     * 第一次请求数据
     */
    const firstDataInit = () => {
      console.log("-------返回---");
      if (!isFromCardDetail) isLoading.value = true;
      pageNumber.value++;
      Promise.all([skuInfoInit(), skuListInit(pageNumber.value)]).then((res) => {
        isLoading.value = false;
        const fetchData = res[res.length - 1];
        const fetchCardList = (fetchData as any).data.data?.card_list || [];
        // 知识卡片曝光埋点
        skuCardExposure(fetchCardList);
        // 渲染lottie
        renderLottie();
        // 检查lottie渲染
        isShow2StarGuide();
        // sku详情浏览埋点 isShowFirstInGuide
        // console.log(isShowFirstInGuide.value,'是否展示1星')
        // console.log(twoStarGuideTitle.value,'是否展示2星')
        if (isShowFirstInGuide.value) {
          star_notice_show_text = oneStarGuideTitle.value;
        } else if (isNeedSetTwoStarGuide.value) {
          star_notice_show_text = twoStarGuideTitle.value;
        } else {
          star_notice_show_text = "";
        }
        skuDetailPageView({
          page_name: "sku_detail",
          source_location,
          sku_name: skuInfo.value["column_title"],
          sku_unid: skuInfo.value["unionid"],
          star_notice_show_text,
        });
      });
    };
    /**
     * 调用端上方法修改actionBar背景颜色
     */
    const changeActionBarInit = () => {
      const params: ChangeActionBarParams = {
        bgColor: "#eef9fd",
        mode: "light",
      };
      changeActionBar(params, (res) => {
        // console.log("h5调用端上changeActionBar", res); // app返回给前端的值
      });
    };
    /**
     * 调用端上方法获取token
     */
    const getTokenFromNative = () => {
      getClientCommonMessage({}, (res) => {
        // console.log("h5调用端上getClientCommonMessage", res); // app返回给前端的值
        if (localStorage.getItem("tal_token") !== res.token) {
          localStorage.setItem("tal_token", res.token);
        }
        user_id = res.user_id;
        // 第一次加载数据
        firstDataInit();
        // 版本判断 <=1.8.0 采用原方案 用原生actionBar, >=1.8.0后 用h5 actionBar
        if (compareVersion(res.service_version_name, "1.8.0") != -1) {
          // 获取状态栏高度 + 计算actionBar高度
          getStatusBarHeight();
          initActionBar();
        } else {
          if (isIOS()) {
            console.log("---- 低版本ios title设置空----");
            document.title = "";
          }
        }
      });
    };
    const initActionBar = () => {
      showActionBar.value = true;
      handlePageScroll();
      Object.assign(actionBarInfo, {
        actionBarTitle: "",
        actionBarBg: "transparent",
      });
    };
    /**
     * 端上调用h5分享sku卡片信息
     */
    const shareInAioInit = (cardId, cardName) => {
      console.log(unionid, cardId, cardName, "分享卡片信息");
      registerFnHandler("shareInAio", (res) => {
        return {
          unionid: cardId,
          sku_unid: unionid || "",
          channelName: "share_common",
          page_name: "sku_detail",
          card_name: cardName,
          sku_name: (skuInfo.value as any).column_title,
        };
      });
    };

    /**
     * 渲染lottie动画
     */
    const renderLottie = (type?) => {
      let lottie_json = gesture_tap_json;
      // await nextTick();
      // setTimeout(() => {
      const lottiePath = "images/";
      const newLottiePath = dealLottiePath(lottiePath);
      lottie_json?.assets?.forEach((item) => {
        item.u = newLottiePath;
      });
      if (type !== 2) {
        lottie.loadAnimation({
          container: document.getElementById("guide-lottie-container"), // 元素动画容器
          renderer: "svg",
          loop: true,
          animationData: lottie_json, // the path to the animation json
        });
      } else {
        lottie.loadAnimation({
          container: document.getElementById("guide-lottie-container2"), // 元素动画容器
          renderer: "svg",
          loop: true,
          animationData: lottie_json, // the path to the animation json
        });
      }

      // }, 50);
    };

    /**
     * 处理页面滚动
     */
    const handlePageScroll = () => {
      if (showActionBar.value) {
        window.addEventListener("scroll", handleTitleChange, true);
      } else {
        isIOS() && window.addEventListener("scroll", handleTitleChange, true);
      }
    };
    /**
     * 页面标题change
     */
    let handleTitleChange = () => {
      // 滚动到标题
      const scrollHeight = 0.64 + 0.51 / 2;
      const scrollT = document.body.scrollTop || document.documentElement.scrollTop;
      const scrollTopRem = scrollT / 37.5;
      if (scrollTopRem > scrollHeight) {
        document.title = (skuInfo.value as any).column_title;
      } else {
        console.log("1.8.0 设置title为空");
        document.title = "";
      }
      // if (scrollT > 0 && showActionBar.value) {
      //   Object.assign(actionBarInfo, {
      //     actionBarTitle: (skuInfo.value as any).column_title,
      //     actionBarBg: "#f3fcff",
      //   });
      // } else if (scrollT === 0 && showActionBar.value) {
      //   Object.assign(actionBarInfo, { actionBarTitle: isIOS() ? "" : (skuInfo.value as any).column_title, actionBarBg: "transparent" });
      // }
      handleTabChange()
    };
    const handleTabChange = () => {

      if (refCardDetailWrap.value && refCardDetailWrap.value.getBoundingClientRect().top < 0) {
          Object.assign(actionBarInfo, {actionBarTitle:(skuInfo.value as any).column_title,
          actionBarBg: "#f3fcff"})
      } else {
          Object.assign(actionBarInfo, {actionBarTitle: isIOS() || showActionBar.value ? "" : (skuInfo.value as any).column_title ,actionBarBg: "transparent"})
      }
      if (refTabWrap.value?.getBoundingClientRect().width && refTabWrap.value?.getBoundingClientRect().top - (showActionBar.value ? actionBarHeight.value : 0) <= 0) {
          displayTabWrapFixed.value = 'block'
      } else  {
          displayTabWrapFixed.value = 'none'
      }
    }
    /**
     * sku详情浏览埋点
     */
    const skuDetailPageView = (params) => {
      $xesLog.view("page_view", params, () => {});
    };
    /**
     * 知识卡片曝光埋点
     */
    const skuCardExposure = (cardList) => {
      let _card_name = [];
      let _star_status = [];
      let _card_type = [];
      cardList.forEach((card) => {
        _card_name.push(card.card_name);
        _star_status.push(`${card.user_card_star}star`);
        _card_type.push(card.card_type === 1 ? "无星" : "3星");
      });
      
      const params = {
        page_name: "sku_detail",
        sku_name: (skuInfo.value as any).column_title,
        sku_unid: unionid,
        card_name: JSON.stringify(_card_name),
        star_status: JSON.stringify(_star_status),
        task_card_type: JSON.stringify(_card_type),
      };
      console.log(params,'_card_type')
      $xesLog.view("knowledge_card_element_show", params, () => {});
    };
    /**
     * 知识卡片点击埋点
     */
    const skuCardClick = (card) => {
      const params = {
        page_name: "sku_detail",
        sku_name: (skuInfo.value as any).column_title,
        sku_unid: unionid,
        card_name: card.card_name,
        star_status: `${card.user_card_star}star`,
        task_card_type: card.card_type === 1 ? "无星" : "3星",
      };
      $xesLog.track("knowledge_card_element_click", params, () => {});
    };

    /**
     * 设置分享卡牌数据
     */
    const setShareInAioData = (tmpCardList) => {
      let currCard;
      // 所有点亮的卡牌列表
      const hasLightStarList = (tmpCardList || []).filter(
        (card) => card.user_card_star > 0
      );
      if (hasLightStarList?.length > 0) {
        currCard = hasLightStarList[hasLightStarList.length - 1];
      } else {
        currCard = tmpCardList?.[0];
      }
      setTimeout(() => {
        currCard?.unionid && shareInAioInit(currCard.unionid, currCard.card_name);
      }, 150);
    };
    onMounted(() => {
      // console.log(window['_dsf'], 'dsbridge 注册的方法')
      // console.log(process.env.NODE_ENV, "process.env.NODE_ENV");
      clickCardStatus.value = true;
      // 改变端上actionBar
      changeActionBarInit();
      // 获取token
      getTokenFromNative();
      // 本地调试
      process.env.NODE_ENV === "development" && firstDataInit();
      // 监听页面滚动
      if (showActionBar.value) {
        handlePageScroll();
      } else {
        isIOS() && handlePageScroll();
      }
    });

    onActivated(() => {
      // 返回后sku详情浏览埋点
      if (isFromCardDetail) {
        displayTabWrapFixed.value = 'none'
        skuDetailPageView({
          page_name: "sku_detail",
          source: "knowledge_card_detail",
        });
      }
      nextTick(() => {
        if (isFromCardDetail) {
          // 返回后重新赋值
          backToTaskReSet();
          // 返回后重新注册 shareInAio分享
          setShareInAioData(cardList.value);
          // 返回后重新绑定scroll
          if (showActionBar.value) {
            handlePageScroll();
          } else {
            isIOS() && handlePageScroll();
          }
          // 改变端上actionBar
          changeActionBarInit();
          // 回到滚动条缓存位置
          scrollToClickPos();
        }
      });
    });

    onDeactivated(() => {
      window.removeEventListener("scroll", handleTitleChange, true);
    });
    watch(
      () => cardList.value,
      (val, oldVal) => {
        if (val.length > 0) {
          setShareInAioData(val);
        }
      }
    );
    // 左侧返回
    const goBack = () => {
      console.log("调用端返回");
      nativeGoBack({ type: "close" }, (res) => {
        console.log("h5调用端上nativeGoBack", res); // app返回给前端的值
      });
    };

    // 获取状态栏高度
    const getStatusBarHeight = () => {
      getStatusBarInfo({}, (res) => {
        console.log("h5调用端上getStatusBarInfo", res); // app返回给前端的值
        statusBarHeight.value = res.height || 35;
        actionBarHeight.value = 44 + res.height || 35;
      });
      // console.log("调用端方法获取高度,先默认写死50");
      // statusBarHeight.value = 50;
    };


    // 跳转外链
    const doJumpVedio = () => {
      const params = {
        page_name: "sku_detail",
        sku_name: (skuInfo.value as any).column_title,
        sku_unid: unionid,
        event_type: "click",
        event_name: "sku详情页攻略介绍按钮点击",
        event_id: "skuDetail_introButton_click",
      };
      $xesLog.track("skuDetail_introButton_click", params, () => {});
      let base = window.location.href.split("#")[0];
      doJump(skuInfo.value["jump_url"], () => {
        console.log("跳转成功");
      });
    };
    // 分享
    const doShare = () => {
      let currCard;
      // 所有点亮的卡牌列表
      const hasLightStarList = (cardList.value || []).filter(
        (card) => card.user_card_star > 0
      );
      if (hasLightStarList.length > 0) {
        currCard = hasLightStarList[hasLightStarList.length - 1];
      } else {
        currCard = cardList.value[0];
      }
      // 调用客户端分享方法
      nativeShowAioShare({
        unionid: currCard.unionid,
        sku_unid: unionid,
        channelName: "share_common",
        page_name: "sku_detail",
        card_name: currCard.card_name,
        sku_name: (skuInfo.value as any).column_title,
      });
    };

    return {
      loading,
      finished,
      skuInfo,
      pageNumber,
      isNoData,
      cardList,
      onLoad,
      pageInfo,
      handleToDetail,
      currentKey,
      scrollToClickPos,
      currenClickItem,
      isShowFirstInGuide,
      clickRefresh,
      showWrongPage,
      isLoading,
      hideFirstInGuide,
      renderLottie,
      skuDetailPageView,
      setShareInAioData,
      goBack,
      statusBarHeight,
      actionBarHeight,
      actionBarInfo,
      getStatusBarHeight,
      showActionBar,
      refTabWrap,
      refCardDetailWrap,
      refSkuBox,
      refTabWrapFixed,
      displayTabWrapFixed,
      doShare,
      isShowTwoStarGuide,
      twoStarGuideTitle,
      doJumpVedio,
      oneStarGuideTitle,
      gradeWrapRef,
      gradeRef,
      gradeOverflow
    };
  },
};
